import CssBaseline from '@mui/material/CssBaseline';
import Header from './home/Header';
import HeroSection from './home/HeroSection';
import Features from './home/Features';
import Testimonials from './home/Testimonials';
import Footer from './home/Footer';

export default function Home() {
  
  return (
    <>
    <CssBaseline />
    <Header />
    <HeroSection />
    <Features />
    <Testimonials />
    <Footer />
    </>
  );
}